export default __webpack_public_path__ + "d0258100e6de96eeca66609f6015a404.png";